import React__default, { useContext } from 'react';
import { a as LocalizationContext } from '../../LocalizationContext-a82461b5.js';
import { L as Label, a as LabelTypography } from '../../index-6420013c.js';
import '../../stringSet-b60e9529.js';
import '../../index-6add7940.js';
import 'prop-types';
var FrozenNotification = function FrozenNotification(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var _useContext = useContext(LocalizationContext),
    stringSet = _useContext.stringSet;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-notification sendbird-notification--frozen ".concat(className)
  }, /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-notification__text",
    type: LabelTypography.CAPTION_2
  }, stringSet.CHANNEL_FROZEN));
};
export { FrozenNotification as default };